module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/flag-red.50b40208.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/FortBattleSeries/images/flag-red.png
// module id = 3223
// module chunks = 11